import React from "react";
import { Navigation } from "../../components";

const Header = () => {
    return <Navigation />;
};

export default Header;
